<div class="donuts" *ngIf="selectedUsers?.length > 0">
	<div class="donut" *ngFor="let basicData of basicDatas; let i = index">
		<app-doughnut-chart [basicData]="basicData" [basicOptions]="basicOptions[i]"
			(chartLoaded)="chartLoaded($event)"></app-doughnut-chart>
	</div>
</div>

<div class="no-user-block" *ngIf="!selectedUsers || selectedUsers.length === 0">
	No Selected Users
</div>